export function parseConfigJson<T>(raw: string, defaults: T): T {
  try {
    if (!raw?.trim()) {
      return { ...defaults };
    }
    const parsed = JSON.parse(raw) as Partial<T>;
    return { ...defaults, ...parsed };
  } catch {
    return { ...defaults };
  }
}

export function stringifyConfigJson(config: object): string {
  const cleaned = removeEmptyObjects(config);
  return JSON.stringify(cleaned);
}

export function parseStringMapping(value: unknown): Record<string, string> {
  if (!value || typeof value !== 'object') {
    return {};
  }

  const result: Record<string, string> = {};
  for (const [key, mappedValue] of Object.entries(value as Record<string, unknown>)) {
    if (typeof mappedValue === 'string' && mappedValue.trim()) {
      result[key] = mappedValue;
    }
  }
  return result;
}

export interface MappingEntry {
  key: string;
  value: string;
}

export function mappingToEntries(mapping: Record<string, string>): MappingEntry[] {
  const entries = Object.entries(mapping).map(([key, value]) => ({ key, value }));
  return entries.length > 0 ? entries : [{ key: '', value: '' }];
}

export function entriesToMapping(entries: MappingEntry[]): Record<string, string> {
  const result: Record<string, string> = {};
  for (const entry of entries) {
    const key = entry.key.trim();
    const value = entry.value.trim();
    if (key && value) {
      result[key] = value;
    }
  }
  return result;
}

export function isInteractiveOperatorType(operatorType: string): boolean {
  const normalized = (operatorType ?? '').trim().toLowerCase();
  return normalized === 'form' || normalized === 'usertask' || normalized === 'modulesurface';
}

export function isServiceOperatorType(operatorType: string): boolean {
  const normalized = (operatorType ?? '').trim().toLowerCase();
  return normalized === 'service' || normalized === 'systemtask';
}

function removeEmptyObjects(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(item => removeEmptyObjects(item));
  }

  if (!value || typeof value !== 'object') {
    return value;
  }

  const result: Record<string, unknown> = {};
  for (const [key, nestedValue] of Object.entries(value as Record<string, unknown>)) {
    const cleaned = removeEmptyObjects(nestedValue);
    if (cleaned === undefined || cleaned === null) {
      continue;
    }
    if (typeof cleaned === 'object' && !Array.isArray(cleaned) && Object.keys(cleaned).length === 0) {
      continue;
    }
    result[key] = cleaned;
  }
  return result;
}
